import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { map, switchMap, catchError, exhaustMap } from 'rxjs/operators';
import { EventState } from '../state/event.state';
import { EventService } from 'app/profile/services/event.service';
import { POST_EVENT, PostEvent, PostEventSuccess, GetSecurityEvent, GET_SECURITY_EVENT, GetSecurityEventSuccess } from '../actions/event.action';
import { IncrementLoaderCount, DecrementLoaderCount, PushError } from 'app/shared/store/actions';


@Injectable()
export class EventEffects {

    constructor(
        private actions$: Actions,
        private store: Store<EventState>,
        private eventService: EventService
    ) { }

    @Effect()
    postEvent$ = this.actions$
        .pipe(
            ofType(POST_EVENT),
            map((action: PostEvent) => action.payload),
            exhaustMap((payload) => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.eventService.PostEvent(payload)
                    .pipe(
                        switchMap((suppliers) => {
                            return [
                                new PostEventSuccess(suppliers),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError((err) => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    )
            })
        );

    @Effect()
    getContracts$ = this.actions$
        .pipe(
            ofType(GET_SECURITY_EVENT),
            map((action: GetSecurityEvent) => action.payload),
            exhaustMap((payload) => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.eventService.GetSecurityEvent(payload)
                    .pipe(
                        switchMap((securityevent) => {
                            return [
                                new GetSecurityEventSuccess(securityevent),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError((err) => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    )
            })
        );
}
